
import * as cloudflareRuntime$xbMxMyrC70t7IZIZTFlfd2Xvz4q0O3FyJT7_fxg_9yg from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxRuntime$QbsAwqw4i3K6HFdcgFAMG_45ZiMMWgblKks3sBK07s8B0 from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$qStsB9Tu_45r2rv6sGBWIdEuytgOKBZpfFdIqVFqlu5IU from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {
    "/tesla": "https://static-assets.tesla.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$xbMxMyrC70t7IZIZTFlfd2Xvz4q0O3FyJT7_fxg_9yg, defaults: {"baseURL":"https://teslemetry.com"} },
  ['ipx']: { provider: ipxRuntime$QbsAwqw4i3K6HFdcgFAMG_45ZiMMWgblKks3sBK07s8B0, defaults: {} },
  ['none']: { provider: noneRuntime$qStsB9Tu_45r2rv6sGBWIdEuytgOKBZpfFdIqVFqlu5IU, defaults: {} }
}
        